import actionTypes from 'constants/actionTypes';
import apiURLBuilder from 'core/apiURLBuilder';
import { result } from 'lodash';
import { APIGet } from 'utilities/APIRequestHelper';

const requestPredictionSearchSuccess = response => {
    return {
        type: actionTypes.BROKER_IA_GET_PREDICTION_SEARCH_SUCCESS,
        payload: {
            data: response,
        },
    };
};

const requestPredictionSearchFetching = () => {
    return {
        type: actionTypes.BROKER_IA_GET_PREDICTION_SEARCH_FETCHING,
    };
};

const requestPredictionSearchFailure = response => {
    return {
        type: actionTypes.BROKER_IA_GET_PREDICTION_SEARCH_FAILURE,
        payload: {
            data: response,
        },
    };
};

const getPredictionSearchResultsAction = (
    dispatch,
    filtersParams,
    predictionSearch = 'brokerIAPredictionSearch'
) => {
    const requestData = { query: { ...filtersParams } };

    dispatch(requestPredictionSearchFetching());

    return APIGet(dispatch, apiURLBuilder.getURL(predictionSearch), requestData)
        .then(response => {
            if (response && response.results && response.results.length > 0) {
                const results = response.results;
                const resultAreInvalid = results.some(result => !result.realTimeValue);
                if (resultAreInvalid) {
                    dispatch(requestPredictionSearchFailure(response));
                } else {
                    dispatch(requestPredictionSearchSuccess(response));
                }
            } else {
              dispatch(requestPredictionSearchSuccess(response));
            }
        })
        .catch(response => {
            dispatch(requestPredictionSearchFailure(response));
        });
};

const getPredictionSearchResults = filtersParams => dispatch =>
    getPredictionSearchResultsAction(dispatch, filtersParams);

module.exports = {
    getPredictionSearchResults,
    getPredictionSearchResultsAction,
};
